import React from 'react'
import logo from '../assets/logo-dark.png'
import '../index.css'

function Header() {

    function Logout(){
        localStorage.removeItem('Sb_UserId')
        window.location.href='/'
    }
    return (
        <div style={{ background: 'white' }}>
            <div className='container' >
                <div className='py-3 d-flex flex-row justify-content-between'  >
                    <img src={logo} />
                    <button className='button_secondary' onClick={()=>Logout()}>Logout</button>
                </div>
            </div>
        </div>


    )
}

export default Header